import i18n from "i18next";

export function columnsQuotes() {
  return [
    {
      id: "qn",
      label: i18n.t("column.quote_hash"),
      minWidth: 60,
      maxWidth: 100,
      align: "left",
    },
    {
      id: "date_inv",
      label: i18n.t("column.date"),
      minWidth: 70,
      maxWidth: 95,
      align: "left",
    },
    // {
    //   id: "mode",
    //   label: i18n.t("column.mode"),
    //   minWidth: 75,
    //   maxWidth: 120,
    //   align: "left",
    // },
    {
      id: "amount",
      label: i18n.t("column.amount"),
      minWidth: 120,
      maxWidth: 125,
      align: "right",
    },
    {
      id: "quote_to",
      label: i18n.t("column.quote_to"),
      minWidth: 180,
      maxWidth: 205,
      align: "left",
    },
    {
      id: "load_address",
      label: i18n.t("column.loading_address"),
      minWidth: 90,
      maxWidth: 130,
      align: "left",
    },
    {
      id: "unload_address",
      label: i18n.t("column.unloading_address"),
      minWidth: 90,
      maxWidth: 130,
      align: "left",
    },
    {
      id: "comment_invs",
      label: i18n.t("column.note"),
      minWidth: 140,
      maxWidth: 160,
      align: "left",
    },
    {
      id: "status",
      label: i18n.t("column.status"),
      minWidth: 100,
      maxWidth: 125,
      align: "left",
    },
    {
      id: "actions",
      label: i18n.t("column.actions"),
      minWidth: 90,
      maxWidth: 95,
      align: "left",
    },
  ];
}
